import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Question } from '../../../models/QuestionResponse';

import { DndDropEvent, DndModule } from 'ngx-drag-drop';

@Component({
  selector: 'q-puzzle',
  standalone: true,
  imports: [DndModule],
  templateUrl: './puzzle.component.html',
  styleUrl: './puzzle.component.scss',
})
export class PuzzleComponent {
  @Input() question!: Question;
  @Input() pickedAnswer!: string;
  @Output() pickedAnswerChange = new EventEmitter<string>();

  answers: (string | null)[] = [];
  possibleChoices: string[] = [];
  bounceIndex: number = -1;

  ngOnInit() {
    this.setupQuestion();
  }

  shuffleArray(array: any[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  setupQuestion() {
    this.answers = this.question.good_answers.map((elt) => null);
    this.possibleChoices = this.shuffleArray([...this.question.good_answers]);
    this.updateAnswer();
  }

  resetQuestion() {
    this.setupQuestion();
  }

  selectChoice(i: number) {
    if (this.isSelected(this.possibleChoices[i])) {
      return;
    }

    const index = this.answers.findIndex((elt) => elt === null);

    if (index !== -1) {
      this.answers[index] = this.possibleChoices[i];

      // Trigger bounce animation
      this.bounceIndex = index;
      setTimeout(() => {
        this.bounceIndex = -1;
      }, 300);
    }

    this.updateAnswer();
  }

  isSelected(answer: string): boolean {
    return this.answers.includes(answer);
  }

  unselectChoice(i: number) {
    this.answers[i] = null;
  }

  shouldBounce(index: number): boolean {
    return this.bounceIndex === index;
  }

  updateAnswer() {
    this.pickedAnswer = this.answers.filter((elt) => elt !== null).join(' ');
    this.pickedAnswerChange.emit(this.pickedAnswer);
  }
}
